import utils from '@/utils';
import requester, { IRequesterResponse } from '@/utils/requester';

const familyApi = {
  async get(data?: { search?: string; page?: number; limit?: number }) {
    const { page = 1, limit = 20, search } = data || {};

    const { offset } = utils.pagination({ page, limit });

    const result: IRequesterResponse = await requester.get(`/user/v1/families`, {
      params: utils.filterObj({
        search,
        offset,
        limit,
      }),
    });
    return result;
  },
};

export default familyApi;
